export const ADD_CATEGORY_FEATURE = "ADD_CATEGORY_FEATURE";
export const SET_CATEGORY_FEATURES = "SET_CATEGORY_FEATURES"
export const SET_ACTIVE_CATEGORY_FEATURE = "SET_ACTIVE_CATEGORY_FEATURE"
export const UPDATE_CATEGORY_FEATURE = "UPDATE_CATEGORY_FEATURE"
export const SET_FILE_LIST = "SET_FILE_LIST" 
export const SET_CLASS_NAME = "SET_CLASS_NAME"
export const SET_STYLE_SHEET = "SET_STYLE_SHEET"
export const SET_CATEGORY = "SET_CATEGORY"
export const DELETE_CATEGORY_FEATURE = "DELETE_CATEGORY_FEATURE"
export const SET_BRANDS = "SET_BRANDS"
export const SET_NAME = "SET_NAME"
export const SET_ORDER = "SET_ORDER"
export const UPDATE_CATEGORY_FEATURE_VALUE = "UPDATE_CATEGORY_FEATURE_VALUE" 
export const TOGGLE_CATEGORY_FEATURE_ACTIVE = "TOGGLE_CATEGORY_FEATURE_ACTIVE"


// WEBPACK FOOTER //
// ./src/components/category-feature/actions/types.js